import { useState } from "react";
import { Link } from "react-router-dom";
import Sidebar from "../components/Sidebar";
import SidebarRight from "../components/Sidebar-Right";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";
import { EXTERNAL } from "../config/links";
import "../styles/Faq.css";

const faqMenu = [
  { key: "faq", label: "FAQ", icon: <i className="fa fa-question" /> },
  { key: "contact", label: "Contact", icon: <i className="fa fa-envelope" /> },
];

const questions = [
  {
    id: "what-is-isn",
    question: "What is ISN Network?",
    answer:
      "ISN Network is a community-driven platform that provides a safe and enjoyable experience for all our members.",
  },
  {
    id: "purchase-items",
    question: "How do I purchase items?",
    answer:
      'You can purchase Zeni or a premium Battlepass by clicking the "Store" button in the navigation bar. This will take you to our store where you can select the items you wish to purchase and complete the transaction securely. The store accepts various payment methods, including credit/debit cards and PayPal. Once your purchase is complete, the items will be delivered to your account automatically.',
  },
  {
    id: "report-issue",
    question: "How do I report an issue?",
    answer:
      'You can report an issue by creating a ticket on our Discord server. Please provide as much detail as possible so that we can assist you effectively.',
  },
  {
    id: "staff-application",
    question: "How do I apply to join the staff team?",
    answer:
      'You can apply to join the staff team by creating a ticket on our Discord server and list your application. Please include your username, age, experience, availability, and why you would like to join the team.',
  },
];

const FAQ = () => {
  const [active, setActive] = useState(faqMenu[0].key);

  return (
    <div className="content">
      <Sidebar />
      <div className="main-content">
        {active === "faq" ? (
          <>
            <h1>Frequently Asked Questions</h1>
            {/* Collapsible so the list stays scannable as it grows.
                `collapsible` lets every item close, rather than forcing one
                open. */}
            <Accordion type="single" collapsible className="faq-accordion">
              {questions.map((item) => (
                <AccordionItem key={item.id} value={item.id}>
                  <AccordionTrigger>{item.question}</AccordionTrigger>
                  <AccordionContent>{item.answer}</AccordionContent>
                </AccordionItem>
              ))}
            </Accordion>
          </>
        ) : (
          <>
            <h1>Contact</h1>
            <p>
              The fastest way to reach us is on Discord. Open a ticket there and
              a staff member will get back to you as soon as they can.
            </p>
            <p>
              <a
                href={EXTERNAL.discord}
                target="_blank"
                rel="noopener noreferrer"
              >
                Join the ISN Network Discord
              </a>
            </p>
            <p>
              Not sure whether your issue warrants a ticket? The{" "}
              <Link to="/rules?section=tickets">Rules</Link> page lists what
              tickets are for and what to include.
            </p>
          </>
        )}
      </div>
      <SidebarRight
        title="Help"
        menu={faqMenu}
        active={active}
        setActive={setActive}
      />
    </div>
  );
};

export default FAQ;
